import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

function LanguageToggle() {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div className="flex items-center space-x-2">
      <span className={`text-sm font-medium transition-colors ${language === 'en' ? 'text-blue-600' : 'text-gray-500'}`}>
        EN
      </span>
      <button
        onClick={toggleLanguage}
        className="relative inline-flex items-center h-6 w-11 rounded-full bg-gray-200 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        style={{ backgroundColor: language === 'es' ? '#2563eb' : '#e5e7eb' }}
      >
        <motion.div
          className="inline-block h-4 w-4 bg-white rounded-full shadow transform transition-transform duration-200"
          animate={{ x: language === 'es' ? 24 : 4 }}
          transition={{ type: "spring", stiffness: 500, damping: 30 }}
        />
      </button>
      <span className={`text-sm font-medium transition-colors ${language === 'es' ? 'text-blue-600' : 'text-gray-500'}`}>
        ES
      </span>
    </div>
  );
}

export default LanguageToggle;